function BwManagement($scope, $controller, $location,  $timeout, $state, $filter, IconsService, GeneralUtilsService) {

	$controller('ConfigController', { $scope: $scope, $timeout: $timeout });


    function compare(a,b) {
      if (a.priority < b.priority)
        return -1;
      if (a.priority > b.priority)
        return 1;
      return 0;
    }

	$scope.$root.hasChanges = function() {
	    return $scope.orig && !(angular.equals(
	                ($scope.orig.qosPolicies),
	                ($scope.tableConfig.items)) ||
	                            angular.equals(
                    ($scope.orig.qosPolicies),
                    ($scope.tableConfig.items)));
	};

	$scope.saveChanges = function() {
	    $scope.account.qosPolicies = $scope.tableConfig.items;
	    $scope.account.newSaveMethod = true;
	    $scope.loading = true;
        store.save({
            path: '/edit',
            data: $scope.account,
            dataObj: 'json',
            queryParams: {
                accountId: $state.params.accountId,
                save: true,
                fields: "['qosPolicies']",
            },
            success: function (data) {
                $scope.loading = false;
                $scope.$root.handleServerResponse(data, '', 'Account settings saved successfully');
                if (data.status !== 'ERROR') {
                    $scope.datamodified = new Date().getTime();
                }
            },
        });
	};


	$scope.baseTableConfig = {
	    noPaging: true,
	    innerLoader: true,
	    id: "qosPolicies",
		pageSize: 5,
		clientSideSort: true,
		fields: [
		      { label: 'Priority', path:'priority', template: '<div><span ng-if="item.priority != 255">P{{item.name}}</span><span ng-if="item.name == 255">Default</span></div>'},
		      { label: 'Limits', path:'threshold', template: "<div ng-hide='item.disabled' ng-disabled='item.priority==255'><select class='form-control' ng-model='item.bwLimitType' ng-options='bwLimitType.value as bwLimitType.key for bwLimitType in tableConfig.bwLimitTypeOptions'></select></div>", noSort: true },
		      { label: '   ', path:'threshold', template: '<div ng-hide="item.disabled" ng-disabled="item.bwLimitType === \'NO_LIMIT\'" class="duplicate-value"><input ng-disabled="item.uploadScale==\'ABSOLUTE\'" type="range" min="1" max="{{item.uploadScale==\'ABSOLUTE\' ? 99999999 : 100}}" value="50" ng-model="item.maxUpload"><input ng-disabled="item.downloadScale==\'ABSOLUTE\'" type="range" min="1" max="{{item.downloadScale==\'ABSOLUTE\' ? 99999999 : 100}}" value="50"ng-model="item.maxDownload"></div>', noSort: true },
		      { label: ' ', path:'titles', template: '<div ng-hide="item.disabled" ng-disabled="item.bwLimitType === \'NO_LIMIT\'" class="duplicate-value"><span style="display:block;padding-bottom:10px;">Upload: </span><span style="display:block;padding-top:10px;"> Download: </span></div>', noSort: true },
		      { label: '', path:'limits', template: '<div ng-hide="item.disabled" ng-disabled="item.bwLimitType === \'NO_LIMIT\'" class="duplicate-value"><span><input  ng-model="item.maxUpload" type="number" class="limit-value" /><input ng-model="item.maxDownload" type="number" class="limit-value"/></span></div>', noSort: true },
		      { label: '  ', path:'selections', template: '<div ng-hide="item.disabled" ng-disabled="item.bwLimitType === \'NO_LIMIT\'" class="duplicate-value"><select ng-model="item.uploadScale" class="form-control limit-scale upper" ng-options="scale.value as scale.name for scale in tableConfig.scales"></select><select ng-model="item.downloadScale" class="form-control limit-scale" ng-options="scale.value as scale.name for scale in tableConfig.scales"></select></div>', noSort: true },
		      { label: 'Class Of Traffic', path:'classOfTraffic', template: "<div class='traffic ellipsis' ><span>{{item.classOfTraffic}}</span></div>", noSort: true }
		],
        scales: [
            {
                value: 'RELATIVE', name: '%',
            },
            {
                value: 'ABSOLUTE', name: 'Mbps',
            }
        ],
        bwLimitTypeOptions: [
        {   value: 'NO_LIMIT',
            key: 'No limit'
        },
        {   value: 'ALWAYS_LIMIT',
            key: 'Always limit'
        },
        {   value: 'LIMIT_WHEN_CONGESTED',
            key: 'Limit only when line is congested'
        }],
        sortList: [{sortField: 'priority', sortDir: 'ASC'}],
        type: 'BandwidthManagementPolicy',

        getLowestFree: function() {
              var lowestQos = 0;
              if (this.items) {
                  lowestQos = Math.max.apply(Math,this.items.map(function(o){return o.priority;}))
              }
              return lowestQos + 10;

          },
		selectedItems: [],
		removeConfirmation: function(items) {if (items.filter(function (qos) {return (qos.classOfTraffic && (qos.classOfTraffic.length > 0))}).length > 0) return "Items in use can not be deleted!"; return null;},
		noSearch: true,
	};

    $scope.tableConfig = angular.copy($scope.baseTableConfig);
    angular.extend($scope.tableConfig, {
        dataURL : function () {return '/bwManagement?accountId=' + ($state.params.accountId ? $state.params.accountId : '');},
        actions : ["remove"],
        addAction : function(type) {
                $scope.newQoS = {id:GeneralUtilsService.getRandomId(),"priority":this.getLowestFree(),"name":this.getLowestFree().toString(), maxDownload:90, maxUpload:90, uploadScale:"RELATIVE", downloadScale:"RELATIVE", bwLimitType: "NO_LIMIT"};
                $scope.$root.openPopup('addProfile');},
        parseData : function(data) {
                $scope.account = data;
                data.qosPolicies = [];
                for (var policy in data.accountPolicies) {
                  data.qosPolicies.push(data.accountPolicies[policy]);
                }
                data.qosPolicies.forEach(function(policy) {policy.priority = parseInt(policy.name);});
                data.qosPolicies.sort(compare);
                $scope.orig = angular.copy(data);
                return data.qosPolicies;
            }
    });




/*** Copy of the policies table, containing static "Default" policy, in order to show the default line ****/
    $scope.defaultTableConfig = angular.copy($scope.baseTableConfig);
	angular.extend($scope.defaultTableConfig, {
	    dataURL : function () {return null;},
	    parseData : function(data) {
                var items = [];
                items.push({
                        priority: 255, name: '255', bwLimitType:'NO_LIMIT', disabled:true});
                getDefaultTraffic();
                return items;
            },
        hideHead : true,
        actionsDisabled : true,
        noSearch : true,
	});

	var getDefaultTraffic = function() {
	    store.fetch({
            path: 'getDefaultQosClassOfTraffic?accountId=' + $state.params.accountId,
            success: function (data) {
                $scope.defaultTableConfig.items[0].classOfTraffic = data;
            },
        });
	};

	$scope.addQos = function() {
	    $scope.newQoS.name = $scope.newQoS.priority;
	    $scope.tableConfig.items.push($scope.newQoS);
	    $scope.tableConfig.refreshViewItems = new Date().getTime();
	    $scope.$root.closePopup('addProfile');
	};

	$scope.scales = $scope.tableConfig.scales;
	$scope.defaultdatamodified = new Date().getTime();
}
